<template>
    <div>
        <div class="break-after width-100 relative m-b-md">
            <h3 class="card-title-text">Instagram preview</h3>
            <Toast width="expand" v-if="errors.msg" :variant="errors.status">{{errors.msg}}</Toast>
        </div>
        <Card>
            <div class="post-preview-wrap" id="instagram-preview">
                <div class="post-preview-user-wrap">
                    <Avatar variant="social-preview"></Avatar>
                    <div class="post-preview-user-info">
                        <div class="flex-content">
                            <div class="width-100 relative">
                                <div class="post-preview-user-name">Cas van Grunsven</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="post.media.type === 'image'" class="post-preview-thumb instagram">
                    <img v-bind:src="post.media.url"/>
                </div>
                <div class="post-preview-content">
                    <div class="post-preview-user-name-inline">casvangrunsven</div>
                    <p>{{post.text}}</p>
                </div>
                <div class="post-preview-dummies">
                    <div class="post-preview-dummy">
                        <svgicon name="heart" />
                    </div>
                    <div class="post-preview-dummy">
                        <svgicon name="comment_rounded" />
                    </div>
                    <div class="post-preview-dummy">
                        <svgicon name="send" />
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>
<script>
    import Card from "../../../Card/Card";
    import Avatar from "../../../Avatar/Avatar";
    import Toast from "../../../Toast/Toast";
    export default {
        name: 'Instagram',
        components: {
            Toast,
            Avatar,
            Card
        },
        props: ['post', 'errors'],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }
</script>
<style src="./Instagram.scss" scoped lang="scss"></style>
